import React, { useState } from 'react';
import Layout from '../../../layout/Layout';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglassHalf } from '@fortawesome/free-solid-svg-icons';
import '../order-tracker.scss';
import StepTracker from './StepTracker';

const Scheduled = ({ activeKey, handleSetActiveKey }) => {
  // State for handling form inputs
  // Add additional states as necessary

  // Function to handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle the form submission logic here
  };

  return (
    <div className="status-bg">
      <StepTracker
        activeKey={activeKey}
        handleSetActiveKey={handleSetActiveKey}
      />
      <Card className="border-0 status-description">
        <Card.Body className="pt-0">
          <Card.Title
            className="step-title text-center d-flex justify-content-center align-items-center"
          >
            Scheduled
          </Card.Title>
          <Card.Text>
            Your ad has now been uploaded for broadcasting.
          </Card.Text>

        </Card.Body>
      </Card>
    </div>

  );
};

export default Scheduled;
